import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../shared/shared/shared.module';
import { DestinationSearchComponent } from './destination-search/destination-search.component';
import { DestinationAddDestinationModalModule } from './destination-add-modal/destination-add-destination-modal.module';
import { CountryCodeService } from '../../../services/country-code/country-code.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    DestinationAddDestinationModalModule,
  ],
  providers: [
    CountryCodeService,
  ],
  declarations: [
    DestinationSearchComponent
  ]
})
export class DestinationSearchModule {
}
